import {ModelInterface} from "../../../data-structures/collection";
import {Moment} from "moment";
import {AiChatMessageType, AiChatParticipant, AIChatProvider, CachedPricing, InputPricing, OutputPricing} from "../@const";
import DatetimeUtils from "../../../gd/utils/datetime-utils";
import AiChatMessage_TokenUsage from "./token-usage/token-usage";


export default class AIChatMessage implements ModelInterface {

    public id               : ID
    public chatId           : ID
    public agentId          : ID | null
    public message          : string
    public messageJson      : any
    public metadata?         : any
    public momentCreated    : Moment
    public parentMessageId  : ID | null
    public recipient        : AiChatParticipant
    public sender           : AiChatParticipant
    public tokens           : AiChatMessage_TokenUsage | null
    public turn             : number
    public type             : AiChatMessageType
    public request          : any
    public response         : any
    public answerTime       : number = 0            // For calculate answer time
    // static initUserQuery: any;

    constructor(data: any) {

        this.id                 = _.get(data, 'id', null)
        this.chatId             = _.get(data, 'chatId', null)
        this.agentId            = _.get(data, 'agentId', null)
        this.message            = _.get(data, 'message', "")
        this.messageJson        = _.get(data, 'messageJson', "")
        this.metadata           = _.get(data, 'metadata', null)
        this.momentCreated      = DatetimeUtils.datetimeToMoment(data['momentCreated'])
        this.parentMessageId    = _.get(data, 'parentMessageId', null)
        this.recipient          = _.get(data, 'recipient', AiChatParticipant.AI)
        this.sender             = _.get(data, 'sender', AiChatParticipant.USER)
        this.tokens             = new AiChatMessage_TokenUsage(data['tokens'])
        this.turn               = _.get(data, 'turn', 0) // 1?
        this.type               = _.get(data, 'type', AiChatMessageType.QUERY)
        this.request            = _.get(data, 'request')
        this.response           = _.get(data, 'response')
    }

    static initUserQuery( message: string, messageJson: any, chatId?: ID){
        return new AIChatMessage({
            id              : null,
            chatId          : chatId,
            message         : message,
            messageJson     : messageJson,
            metadata        : null,
            momentCreated   : moment(),
            recipient       : AiChatParticipant.AI,
            sender          : AiChatParticipant.USER,
            tokens          : {},
            turn            : 0,
            type            : AiChatMessageType.QUERY
        })
    }


    get isAnswer (): boolean {
        return this.type === AiChatMessageType.ANSWER
    }

    get isQuery (): boolean {
        return this.type === AiChatMessageType.QUERY
    }

    get isContext (): boolean {
        return this.type === AiChatMessageType.CONTEXT
    }

    get isToolsCallsRequest(): boolean {
        return this.type === AiChatMessageType.TOOLS_CALL_REQUEST
    }

    get isToolsCallsResponse (): boolean {
        return this.type === AiChatMessageType.TOOLS_CALL_RESPONSE
    }

    get isError (): boolean {
        return this.type === AiChatMessageType.ERROR
    }

    get isToolSelection (): boolean {
        return this.type === AiChatMessageType.TOOLS_SELECTION
    }
    get isAiVectorGeneration (): boolean {
        return this.type === AiChatMessageType.STRING_TO_VECTOR
    }
    get isChatName (): boolean {
        return this.type === AiChatMessageType.CHAT_NAME
    }
    get isCompaction (): boolean {
        return this.type === AiChatMessageType.COMPACTION
    }

    get isBackendAiTurnsExited (): boolean {
        return this.type === AiChatMessageType.BACKEND_AI_TURNS_EXITED
    }

    get cost(): number {
        const model = AIChatProvider.GPT_4o_MINI;

        const inputPrice  = InputPricing[model]  ?? 0;
        const outputPrice = OutputPricing[model] ?? 0;
        const cachedPrice = CachedPricing[model] ?? 0;

        const inputTokens  = this.tokens?.inputTokens  ?? 0;
        const outputTokens = this.tokens?.outputTokens ?? 0;
        const cachedTokens = this.tokens?.cachedTokens ?? 0;

        return (
            (inputTokens-cachedTokens)  * inputPrice +
            outputTokens * outputPrice +
            cachedTokens * cachedPrice
        ) / 1_000_000;
    }



    toJSON() {
        return {
            id              : this.id,
            chatId          : this.chatId,
            agentId         : this.agentId,
            message         : this.message,
            messageJson     : this.messageJson,
            metadata        : this.metadata,
            momentCreated   : this.momentCreated.toJSON(),
            parentMessageId : this.parentMessageId,
            recipient       : this.recipient,
            sender          : this.sender,
            tokens          : this.tokens,
            turn            : this.turn,
            type            : this.type,
            request         : this.request,
            response        : this.response,
        }
    }
}
